import React from "react";
import { Droppable } from 'react-beautiful-dnd';

const SarasDnDList = ({groupKey, sarasDnDManager, children, customWrapper}) => {
    const style = {
        minHeight: '100px',
        height:"100%",
        minWidth: '143px'
    };

    return (
        <Droppable key={groupKey} droppableId={groupKey} type={sarasDnDManager.dndType}>
        {(provided, snapshot) => (
            <ul
            className={"uiDnDDropTarget " + (snapshot.isDraggingOver ? "uiDnDDragOverList" : "")}
            ref={provided.innerRef}
            style={style}
            {...provided.droppableProps}
            >
                {children}
                {provided.placeholder}
            </ul>
        )}
        </Droppable>
    )
};

export default SarasDnDList;
